import {useEffect, useState} from 'react';

import sdk from '@/sdk';
import * as store from '@/store';
// import {EDITOR_MODE} from '@/Constant';
// import {SideTabKey} from '@/interface';
import {loadFlowSDK, getToken} from '@/utils/document/flowSDK';
import {isInKuShare} from '@/utils/urlUtils';
import {getIsBaikeRepo} from '@/pages/baike/utils';

// import {ContinueChatData} from '../interface';
// import {openPanel} from '../utils/panelStatus';
import {chatButtonClickCallback} from '../utils/chatButtonClickCallback';

const kuEnv = process.env.REACT_APP_ENVIRONMENT;

const envMap = {
    local: 'test',
    rd: 'test',
    qa: 'test',
    gray: 'gray',
    online: 'online',
};

// @ts-ignore 忽略类型检查
const sdkEnv = envMap[kuEnv] || envMap.online;

// 实例，全局唯一
let flowSDKOCR: any = null;
let ocrReady = false;

export const useOCRInit = (demoMode: boolean) => {
    const [, setReady] = useState(false);

    useEffect(() => {
        if (!flowSDKOCR && !window.isTocPage) {
            loadFlowSDK().then((flowSDK) => {
                if (flowSDK.ocr) {
                    flowSDK.ocr.init({
                        env: sdkEnv,
                        getToken: getToken,
                        userId: sdk.user?.rlId,
                        userName: sdk.user?.rlName,
                        chatButtonClickCallback,
                    }).then((instance: any) => {
                        flowSDKOCR = instance;
                        (window as any).flowSDKOCR = flowSDKOCR;
                        ocrReady = true;
                        setReady(true);

                        const kuShareOrBaike = isInKuShare()
                            || getIsBaikeRepo(store.getCurDocument()?.repositoryGuid || '');
                        const settingOpenOCR = !!sdk.user?.settings.newSettings.intelligent.openOCR;
                        if (kuShareOrBaike) {
                            flowSDKOCR.disable();
                        } else if (settingOpenOCR) {
                            flowSDKOCR.enable();
                        } else {
                            flowSDKOCR.lockOCR();
                        }
                    });
                }
            }).catch(err => {
                console.error(err);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const kuShareOrBaike = isInKuShare()
            || getIsBaikeRepo(store.getCurDocument()?.repositoryGuid || '');
        const settingOpenOCR = !!sdk.user?.settings.newSettings.intelligent.openOCR;
        if (!demoMode && !kuShareOrBaike) {
            if (settingOpenOCR) {
                flowSDKOCR?.enable();
            } else {
                flowSDKOCR?.lockOCR();
            }
        } else {
            flowSDKOCR?.disable();
        }
    }, [demoMode]);

    useEffect(() => {
        return () => {
            flowSDKOCR?.disable();
        };
    }, []);

    return ocrReady;
};
